/* src/app/pages/message/user-group-select/user-group-select.page.scss */
oden-cell {
  border-bottom: 0px;
}
.border-row {
  border-bottom: 1px solid #424242 !important;
  display: flex;
}
oden-select::ng-deep .width-custom {
  min-width: 150px !important;
}
/*# sourceMappingURL=user-group-select.page.css.map */
